import * as React from "react";
import * as ReactDOM from "react-dom";
import { useDimensions } from "../hooks/useDimensions";
import { randomString } from "../utils";
import { Frame } from "./Frame";
import { Reflection } from "./Reflection";
/**
 * Create reflection wrapped in frame element
 */
export function Mirror({ className, frameProps, reflect }) {
    const { instanceId, real } = React.useMemo(() => ({
        /** Unique identifier of this mirror */
        instanceId: randomString(7),
        /** Actual DOM node of react element being reflected */
        real: getRealNode(reflect),
    }), [reflect]);
    const { top, bottom, left, right } = useDimensions(real);
    return (React.createElement(Frame, Object.assign({ className: className, height: bottom - top, id: instanceId, width: right - left }, frameProps),
        React.createElement(Reflection, { real: real, style: { pointerEvents: "none" } })));
}
function getRealNode(instance) {
    var _a;
    try {
        // eslint-disable-next-line react/no-find-dom-node
        return (_a = ReactDOM.findDOMNode(instance)) !== null && _a !== void 0 ? _a : undefined;
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.warn(e);
        return;
    }
}
